namespace Gordic.Adm.WebControls.FunctionsAdmParametrGlobal {
    export function createContenxtHelpString(uroven: number): string {
        switch (uroven) {
            case 20:
                return "ico";
            case 30:
                return "databaze";
            case 35:
                return "stredisko"; 
            case 38:
                return "faze"
            case 40:
                return "instance";
            case 60:
                return "funkce";
            case 70:
                return "externiSystem";
            default:
                return "global";
        }
    } 
}